module.exports = __webpack_public_path__ + "2ff60cd61cfa8f81c4ac10ce72c5a740.MP3";